import { toast } from 'react-toastify'

import { credentialsVar } from '../cache/auth'
import apolloClient from '../graphql/apolloClient'
import { LOGOUT_MUTATION } from '../graphql/auth'
import { buildLoginUrl } from './sessionRedirect'
import { clearSupportDrafts } from './supportDraft'

export const logout = async () => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: LOGOUT_MUTATION
    })

    if (data?.logout?.message) {
      toast.success(data.logout.message)
    }
  } catch (err: any) {
    const msg = (err.message || '').toLowerCase()

    // These are "acceptable" logout errors — treat as already logged out
    if (
      msg.includes('unauthenticated') ||
      msg.includes('unauthorized') ||
      msg.includes('invalid token') ||
      msg.includes('refresh token') ||
      msg.includes('session is not active') ||
      msg.includes('not found')
    ) {
      // silent or soft toast
      // toast.info("Session already ended")
    } else {
      toast.error('Logout failed: ' + (err.message || 'Unknown error'))
    }
  }

  // ────────────────────────────────────────────────
  // ALWAYS do this — no matter success or failure
  // ────────────────────────────────────────────────
  credentialsVar(undefined)
  clearSupportDrafts()
  localStorage.setItem('logout', Date.now().toString())

  if (!window.location.pathname.includes('/login')) {
    window.location.href = `${window.location.origin}${buildLoginUrl()}`
  }
}
